export default "a0682a9e38d2d424.svg"